import MetaIdbRepository from "repositories/idb/MetaIdbRepository";
import { IApplicationRightService, ApplicationRightService } from 'services/ApplicationRightService';
import { ApplicationRightProps } from 'components/props/ApplicationRightProps';

import { ModuleProps, CreateModuleProps } from "components/props/ModuleProps";
import { ApplicationRightSystemNames } from "../components/constants";

// Dynamically import all Module.tsx files from modules folder
const moduleFiles = import.meta.glob<{ Module: ModuleProps }>('../modules/**/Module.tsx', { eager: true });

// Extract Module exports from all imported files
const dynamicModules: ModuleProps[] = Object.values(moduleFiles).map(file => file.Module);

// Core system modules (non-plugin modules)
const coreModules: ModuleProps[] = [
    CreateModuleProps({
        id: "MY_PILOT_ASSIGNMENTS",
        applicationRights: [ApplicationRightSystemNames.WEB_MODULE_MY_PILOT_ASSIGNMENTS_WRITE],
        title: 'Mine oppdrag',
        text: 'Mine oppdrag',
        icon: 'ship',
        onlineOnly: false,
        url: "/pilot/pilotages/",
        sequenceNo: 1000
    }),
    CreateModuleProps({
        id: "CURRENT_PILOTAGES",
        applicationRights: [ApplicationRightSystemNames.WEB_MODULE_CURRENT_PILOTAGES_READ],
        title: 'Alle oppdrag',
        text: 'Alle oppdrag',
        icon: 'ship',
        url: "/pilotages/current",
        sequenceNo: 2000
    }),

    CreateModuleProps({
        id: "INCIDENTS",
        applicationRights: [
            ApplicationRightSystemNames.WEB_MODULE_INCIDENTS_WRITE,
            ApplicationRightSystemNames.WEB_MODULE_INCIDENTS_CASEHANDLER_WRITE
        ],
        title: 'Hendelser',
        text: 'Hendelser',
        icon: 'warning',
        showOnDashboardByDefault: false,
        url: "/incident",
        sequenceNo: 12000
    }),
    
];

const modules: ModuleProps[] = [
    
    ...coreModules,

    ...dynamicModules
];

export const ModuleService = {

    getModules(): ModuleProps[] {
        return modules;
    },

    getParentModules(): ModuleProps[] {
        return modules
            .filter(m => !m.parentId)
            .sort(this.sortModules);
    },

    getOfflineParentModules(): ModuleProps[] {
        return modules
            .filter(m => !m.parentId && m.onlineOnly === false)
            .sort(this.sortModules);
    },

    getChildModules(parentId: string): ModuleProps[] {
        return modules
            .filter(m => m.parentId === parentId)
            .sort(this.sortModules);
    },

    getDashboardModules(): ModuleProps[] {
        return modules
            .filter(m => m.canShowOnDashboard)
            .sort(this.sortModules);
    },

    getModuleById(moduleId: string): ModuleProps {
        const module = modules.find(m => m.id === moduleId);
        return module!;
    },

    async setDefaultDashboard(applicationRights: ApplicationRightProps[]):Promise<void> {

        const applicationRightService: IApplicationRightService = new ApplicationRightService(applicationRights);
        const results: ModuleProps[] = [];

        modules.forEach((module) => {

            if (
                module.canShowOnDashboard === true &&
                module.showOnDashboardByDefault === true &&
                applicationRightService.canAccess(module.applicationRights || [])
            ) {
                results.push({
                    id: module.id,
                    applicationRights: module.applicationRights,
                    sequenceNo: module.sequenceNo,
                    selected: true,
                    text: module.text,
                    icon: module.icon,
                    minWidth: module.minWidth,
                    url: module.url,
                    onlineOnly: module.onlineOnly
                });
            }
        });

        await MetaIdbRepository.setModulesAsync(results);
    },

    // Private helper method for consistent sorting
    sortModules(a: ModuleProps, b: ModuleProps): number {
        // First sort by sequenceNo
        if (a.sequenceNo !== b.sequenceNo) {
            return a.sequenceNo - b.sequenceNo;
        }
        // If sequenceNo is the same, sort by title
        return (a.title || '').localeCompare(b.title || '');
    }
}
